<template>
	<div class="main">
		<div class="body">
			<slot />
		</div>
	<footer-bar />
	</div>
</template>

<script setup lang="ts">
//  hardcode import from vue-router #imports has a bug
import { useHead } from '#imports';

// Head
useHead({
	title: 'Lapilab',
	meta: [
		{ name: 'description', content: 'We make great games for everyone!' },
		{ name: 'theme-color', content: '#333333' },
		{ name: 'apple-mobile-web-app-capable', content: 'yes' },
		{ name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
		{ name: 'og:title', content: 'Lapilab' },
		{ name: 'og:description', content: 'We make great games for everyone!' },
		// { name: 'og:image', content: 'https://cdn.outfit7.com/web/transfered/HDS.png' },
		{ name: 'og:url', content: 'www.lapilab.io' }
	]
});
</script>

<style scoped lang="scss">
@import '~/assets/design';

.main {
	position: relative;
	display: block;
	width: 100%;
	min-width: $size-content-width-min;
	min-height: 100%;
	padding-top: 10px;
	// Margin to account for the fixed header height
	margin: 70px auto 0;
	overflow-x: hidden;
	background: #151515;

	.body {
		height: 100%;
		padding: env(safe-area-inset-top) 0 0 0 !important;
		margin: -2px auto 0;
		background: #151515;
	}
}
</style>
